export default "__VITE_ASSET__Dfqj0ttw__"